import { GovFlex, GovIcon, GovMessage } from '@gov-design-system-ce/react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { MyFilesOrder, useMojeSouborySeznamContext } from '@gov-nx/module/page';
import { SortArrows, Space } from '@gov-nx/ui/web';
import { DocumentsActions } from '../DocumentsActions';
import { SelectAll } from '../SelectAll';

export const TableHead = () => {
	const { code, myFilesFilters, myFilesSelection, isSelectedWithoutFile } =
		useMojeSouborySeznamContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);

	return (
		<GovFlex
			direction="column"
			gap="s"
			className="pt-(--templates-margin-s) pb-(--templates-margin-s) pl-(--templates-margin-l) pr-(--templates-margin-l) bg-(--background-block-secondary) rounded-lg">
			{myFilesSelection.selected.length > 0 ? (
				<GovFlex direction="column">
					<GovFlex
						justifyContent="space-between"
						alignItems="center"
						gap="s"
						className="pb-(--templates-margin-s)">
						<span className="font-bold text-(--text-secondary)">
							{tsn('vyber.vybrano')}:<Space />
							{myFilesSelection.selected.length}
						</span>
						<DocumentsActions />
					</GovFlex>

					{myFilesSelection.isItemWithNoFileInSelection &&
						!isSelectedWithoutFile && (
							<GovMessage
								color="primary"
								type="subtle"
								icon={
									<GovIcon
										type="components"
										name="info-circle-fill"
									/>
								}>
								{tsn('info.vybrany-soubor-bez-prilohy')}
							</GovMessage>
						)}
				</GovFlex>
			) : null}
			<GovFlex
				alignItems="center"
				gap="s"
				responsive="false">
				<span className="mr-auto! text-left font-normal text-(--text-primary-color)">
					{tsn('data.nazev-souboru')}
					<SortArrows
						descWcagLabel={`${tsn('razeni.title')}: ${tsn(
							'zaznam.nazev-souboru'
						)} - ${tsn('razeni.sestupne')}`}
						descOnClick={() =>
							myFilesFilters.sortFilesBy(MyFilesOrder.NAZEV_DESC)
						}
						ascWcagLabel={`${tsn('razeni.title')}: ${tsn(
							'zaznam.nazev-souboru'
						)} - ${tsn('razeni.vzestupne')}`}
						ascOnClick={() => myFilesFilters.sortFilesBy(MyFilesOrder.NAZEV)}
					/>
				</span>
				<span className="w-36 pl-1 text-right font-normal text-(--text-primary-color) whitespace-nowrap hidden [ md:block ]">
					{tsn('data.pridano')}
					<SortArrows
						descWcagLabel={`${tsn('razeni.title')}: ${tsn(
							'zaznam.pridano'
						)} - ${tsn('razeni.sestupne')}`}
						descOnClick={() =>
							myFilesFilters.sortFilesBy(MyFilesOrder.DATUM_VYTVORENI_DESC)
						}
						ascWcagLabel={`${tsn('razeni.title')}: ${tsn(
							'zaznam.pridano'
						)} - ${tsn('razeni.vzestupne')}`}
						ascOnClick={() =>
							myFilesFilters.sortFilesBy(MyFilesOrder.DATUM_VYTVORENI)
						}
					/>
				</span>
				<SelectAll />
			</GovFlex>
		</GovFlex>
	);
};
